<script setup lang="ts">
import { defineProps } from "vue";
import i18n from "@/lang/i18n";
import { OUTPUT_PDF_TYPE_TEMPERATURE_GRAPH, OUTPUT_PDF_TYPE_TEMPERATURE_LIST } from "@/services/consts";
import UpsertCsvButtons from "@/components/Common/UpsertCsvButtons.vue";
import { computed } from 'vue'

const emits = defineEmits(['downloadPdf']);
const IMPORT_TYPE = "App\\Services\\Csv\\Upserts\\Imports\\SensorService";
const EXPORT_TYPE = "App\\Services\\Csv\\Upserts\\Exports\\SensorService";

const props = defineProps<{
  pdfBtnShoweableState: boolean;
  pdfGraphLoading: boolean;
  pdfListLoading: boolean;
  isManagementOffice: boolean;
  chartDetails: {
    start_date_time: string;
    end_date_time: string;
    operation_office_id: number;
    vehicle_id: string;
  }
  fetchData: () => void;
  authorities: {
    import: boolean;
    export: boolean;
  };
}>();

const isDisabledCsvUpsertBtn = computed(() => {
  if (!props.chartDetails.start_date_time || !props.chartDetails.end_date_time) {
    return true;
  }
  const start = new Date(props.chartDetails.start_date_time);
  const end = new Date(props.chartDetails.end_date_time);
  const diff = end.getTime() - start.getTime();
  return diff > 24 * 60 * 60 * 1000; // 1day by milliseconds
});

function downloadPdf(type: string) {
  emits('downloadPdf', type);
}
</script>
<template>
  <div class="btn-area mb-4 d-flex justify-center" v-if="props.pdfBtnShoweableState">
    <v-btn
      class="exec-btn mt-0 ml-4"
      :loading="props.pdfGraphLoading"
      :disabled="props.pdfListLoading"
      :style="{
        backgroundColor: props.pdfListLoading ? '#B3B8BB' : '',
      }"
      width="15%"
      @click="downloadPdf(OUTPUT_PDF_TYPE_TEMPERATURE_GRAPH)"
      >
        {{ i18n.global.t('pages.temperatureSensors.charts.button.pdfGraph') }}
    </v-btn>
    <v-btn
      class="exec-btn mt-0 ml-4"
      :loading="props.pdfListLoading"
      :disabled="props.pdfGraphLoading"
      :style="{
        backgroundColor: props.pdfGraphLoading ? '#B3B8BB' : '',
      }"
      width="15%"
      @click="downloadPdf(OUTPUT_PDF_TYPE_TEMPERATURE_LIST)"
      >
        {{ i18n.global.t('pages.temperatureSensors.charts.button.pdfList') }}
    </v-btn>
    <div
      class="ml-3"
      style="width: 15%;"
    >
      <UpsertCsvButtons
        :title="i18n.global.t('pages.common.button.csvUpsert')"
        :importTitle="i18n.global.t('pages.temperatureSensors.csvImportTitle')"
        :importType="IMPORT_TYPE"
        :exportType="EXPORT_TYPE"
        :filterItems="props.chartDetails"
        :authorities="{
          csvImport: props.authorities.import,
          csvExport: props.authorities.export
        }"
        :isDisabled="isDisabledCsvUpsertBtn"
        :getList="props.fetchData"
        elementId="sensor-upsert"
        btnClass="exec-btn mt-0 ml-1 w-100"
        dropDownStyle="width: 100%;"
      />
    </div>
  </div>
</template>